<div
	class="flex gap-2 items-center"
	[ngClass]="{
		'justify-start ml-2': headerService.menuOpened(),
		'justify-center': !headerService.menuOpened(),
	}"
>
	<div><app-svg-asset [ds]="false" name="images/profile-circle" class="w-8 h-8" /></div>
	<div class="flex flex-col" [class.hidden]="!headerService.menuOpened()">
		<div class="text-base font-semibold">{{ adminName() }}</div>
		<div class="text-xs font-semibold">{{ adminRole() }}</div>
	</div>
</div>
